<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img
        class="c-sidebar-brand-full"
        src="/img/logo.png"
        height="30"
        style="margin-left: -15px; margin-top: 5px"
        alt="logo"
      />
      <img
        class="c-sidebar-brand-minimized"
        src="/img/icons/favicon-32x32.png"
        height="30"
        alt="logo"
      />
    </CSidebarBrand>

    <CRenderFunction
      flat
      :content-to-render="nav.getNavList()"
    />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import Nav from "./_nav";
import store from "@/store";

export default {
  name: "TheSidebar",
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
  },

  data() {
    return {
      app: store.state.app,
      nav: Nav,
    };
  },
};
</script>
